import { render, staticRenderFns } from "./ContactBanner.vue?vue&type=template&id=4aba0cce&scoped=true&"
import script from "./ContactBanner.vue?vue&type=script&lang=ts&"
export * from "./ContactBanner.vue?vue&type=script&lang=ts&"
import style0 from "./ContactBanner.vue?vue&type=style&index=0&id=4aba0cce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba0cce",
  null
  
)

export default component.exports